/**
 * Explore Our Renders Component
 * Displays a grid of render preview images
 */

const ExploreRenders = () => {
  const renders = Array.from({ length: 8 }, (_, i) => ({
    id: i + 1,
    image: `/api/placeholder/300/300`,
  }));

  return (
    <div>
      {/*<h2 className="text-2xl font-bold text-gray-800 mb-6">Mood Boards</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {renders.map((render) => (
          <div
            key={render.id}
            className="aspect-square bg-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow cursor-pointer group relative"
          >
            {/* Placeholder Image *-/}
            <div className="w-full h-full flex items-center justify-center">
              <svg
                className="w-16 h-16 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              {/* Mountain and sun icon placeholder *-/}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-gray-400 text-4xl">🏔️</div>
              </div>
            </div>

            {/* Hover overlay *-/}
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-opacity"></div>
          </div>
        ))}
      </div>*/}
    </div> 
  );
};

export default ExploreRenders;
